import { NgModule } from '@angular/core';
import { VersionModalComponent } from './version-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [VersionModalComponent],
  imports: [NgbModule, HttpClientModule, CommonModule, ReactiveFormsModule],
  exports: [VersionModalComponent],
})
export class VersionModalModule {}
